module.exports = __webpack_public_path__ + "img/nodejs.f6bdb1ab.svg";